function initMetrika(w) {
	(function (m, e, t, r, i, k, a) {
		m[i] = m[i] || function () {
			(m[i].a = m[i].a || []).push(arguments)
		};
		m[i].l = 1 * new Date();
		k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
	})
	(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

	ym(45775443, "init", {
		triggerEvent: true,
		accurateTrackBounce: true,
		clickmap: true,
		webvisor: true
	});

	$(document).on('yacounter45775443inited', function () {
		window.yacounter45775443inited = true;
	});
}

function viewpageMetrika() {
	if (undefined !== window.yacounter45775443inited) {
		ym(45775443, 'hit', urlhelper.getCurrentUrl());
	}
}